<template>
  <div>
    <div class="columns">
      <div class="column">
        <div class="title is-4">{{ title }}</div>
      </div>
      <div class="column is-narrow">
        <slot name="navigation"></slot>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <DataTable
          :loading="loading"
          :listData="listData"
          :listHeader="listHeader"
          :total="listTotal"
          :route="route"
          :checkable="checkable"
          :defaultSortField="'date'"
          :defaultSortOrder="'desc'"
          @loadData="getData"
          @loadHeader="getHeader"
          @rowChecked="rowChecked"
          ref="dataTable"
        >
          <template v-slot:actions>
            <div class="column is-narrow options" v-if="checked.length !== 0">
              <b-dropdown aria-role="list" position="is-bottom-left">
                <button class="button is-warning" slot="trigger">
                  <span>Действия</span>
                  <b-icon icon="menu-down"></b-icon>
                </button>
                <b-dropdown-item
                  aria-role="listitem"
                  @click="openDuplicateConfirmationModal"
                  >Дублировать</b-dropdown-item
                >
                <b-dropdown-item
                  aria-role="listitem"
                  @click="openDeleteConfirmationModal"
                  >Удалить</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </template>
          <template v-slot:rowActions="id">
            <b-button
              @click="toggleGenerateModal(id)"
              size="is-small"
              type="is-warning"
              >Создать документ</b-button
            >
          </template>
        </DataTable>
        <b-modal :active.sync="isDeleteModalShown" has-modal-card>
          <ConfirmationModal @confirm="deleteRows" :settings="deleteModal" />
        </b-modal>
        <b-modal :active.sync="isDuplicateModalShown" has-modal-card>
          <ConfirmationModal @confirm="duplicateRows" />
        </b-modal>
      </div>
    </div>

    <b-modal
      :active.sync="generateDocumentModal"
      class="has-overflow"
      has-modal-card
      :can-cancel="canCancel"
    >
      <GenerateDocumentModal
        @generateDocument="generateDocument"
        :templateId="activeTemplateId"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      userId: state => state.auth.userId,
      listData: state => state.templates.listData,
      listTotal: state => state.templates.listTotal,
      listHeader: state => state.templates.listHeader,
    }),
  },
  components: {
    DataTable: () =>
      import(
        /* webpackChunkName: "DataTable" */ '@/components/shared/DataTable.vue'
      ),
    ConfirmationModal: () =>
      import(
        /* webpackChunkName: "ConfirmationModal" */ '@/components/layout/ConfirmationModal.vue'
      ),
    GenerateDocumentModal: () =>
      import(
        /* webpackChunkName: "GenerateDocumentModal" */ '@/components/shared/document/GenerateDocumentModal'
      ),
  },
  data() {
    return {
      loading: true,
      checkable: true,
      checked: [],
      title: 'Шаблоны',
      route: 'template.view',
      params: {},
      isDeleteModalShown: false,
      activeTemplateId: '',
      canCancel: ['escape', 'x'],
      deleteModal: {
        confirm: 'Удалить',
        cancel: 'Отменить',
        title: 'Удлить позиции',
        confirmButtonColor: 'is-danger',
      },
      generateDocumentModal: false,
      isDuplicateModalShown: false,
    }
  },
  methods: {
    ...mapActions('templates', {
      getTemplates: 'getTemplates',
      getTemplatesHeader: 'getTemplatesHeader',
    }),
    ...mapActions('template', {
      deleteTemplate: 'deleteTemplate',
      duplicateTemplate: 'duplicateTemplate',
    }),
    ...mapActions('document', {
      postDocument: 'postDocument',
    }),
    toggleGenerateModal(id) {
      this.activeTemplateId = id.id
      this.generateDocumentModal = true
    },
    async generateDocument(variables) {
      this.isLoading = true
      const data = {
        templateId: this.activeTemplateId,
        data: {
          variables: variables,
        },
      }

      await this.postDocument(data)
        .then(res => {
          this.$router.push({
            name: 'document.view',
            params: { id: res.data.id },
          })
        })
        .catch(err => {
          this.toast({
            message: `Ошибка ${err}`,
            type: 'is-danger',
          })
        })

      this.activeTemplateId = ''
      this.isLoading = false
    },
    rowChecked(data) {
      this.checked = data.map(row => row.id)
    },
    openDuplicateConfirmationModal() {
      this.isDuplicateModalShown = true
    },
    async duplicateRows() {
      this.isDuplicateModalShown = false
      this.loading = true
      for (let i = 0; i < this.checked.length; i++) {
        const element = this.checked[i]
        await this.duplicateTemplate(element)
      }
      this.$refs.dataTable.checkedRows = []
      await this.getData(this.params)
    },
    openDeleteConfirmationModal() {
      this.isDeleteModalShown = true
    },
    async deleteRows() {
      this.isDeleteModalShown = false
      this.loading = true
      for (let i = 0; i < this.checked.length; i++) {
        const element = this.checked[i]
        await this.deleteTemplate(element)
      }
      this.$refs.dataTable.checkedRows = []
      await this.getData(this.params)
    },
    async getHeader() {
      await this.getTemplatesHeader()
    },
    async getData(params) {
      this.params = params
      this.loading = true
      await this.getTemplates(this.params).then(() => (this.loading = false))
    },
  },
}
</script>
